import TemplateView from '../TemplateView'
import Button from '../components/Button'
import messageResource from '../messageResource'

export default class CreateFooter extends TemplateView {

    constructor({
        additionalClass = '',
        submitBtnLabelMsgKey = '',
        withPlusIcon = false,
        onSubmitCb = () => {},
        onCancelCb = () => {}
    }) {
        super(null)

        this.callbacks = {
            onSubmitCb,
            onCancelCb
        }

        this.params = {
            submitBtnLabelMsgKey,
            withPlusIcon,
            additionalClass,
        }

        this.state = {
            hasErrors: false,
            saving: false
        }

        this.onStatePropertyChanged("hasErrors", hasErrors => {
            this.errorMessageBox.toggle(hasErrors)
        })

        this.onStatePropertyChanged("saving", saving => {
            this.find(".savingMsg").toggleClass('invisible', !saving)
            this.submitButton.setState({disabled: saving})
            this.cancelButton.setState({disabled: saving})
        })
    }

    templateHtml() {
        return '<div class="createPanel_footer <%=additionalClass%>">' +
               '    <div class="errorMessageBox">' +
               '        <div class="errorIcon"/>' +
               '        <span class="errormsg"><%-errorMsg%></span>' +
               '    </div>' +
               '    <div class="changesBox">' +
               '        <span class="savingMsg invisible"><%-savingMsg%></span>' +
               '    </div>' +
               '    <div class="buttonsBox"/>' +
               '</div>'
    }

    afterRender() {
        this.errorMessageBox = this.find(".errorMessageBox")
        const $buttonsBox = this.find(".buttonsBox")

        this.submitButton = new Button({
            additionalClass: 'submitBtn',
            withPlusIcon: this.params.withPlusIcon,
            label: messageResource.getMessage(this.params.submitBtnLabelMsgKey),
            onClickCb: () => {
                if (!this.state.saving) this.callbacks.onSubmitCb()
            }
        }).init($buttonsBox)

        this.cancelButton = new Button({
            additionalClass: 'cancelBtn',
            label: messageResource.getMessage('common.cancel'),
            onClickCb: () => {
                if (!this.state.saving) this.callbacks.onCancelCb()
            }
        }).init($buttonsBox)

        this.renderInitialState()
    }

    messageKeys() {
        return {
            errorMsg: 'user.add_edit.js.footer_error.exist_invalid_fields',
            changesMsg: 'user.add_edit.not_saved',
            savingMsg: 'user.add_edit.saving',
        }
    }

    templateModel() {
        return {
            additionalClass: this.params.additionalClass,
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/CreateFooter.js